import { Camera, Download, Handshake, QrCode, ShieldCheck } from "lucide-react";
import { Eyebrow, MaskLines, Reveal } from "@/components/site/Motion";

const Card = ({ className = "", children, delay = 0, testid }) => (
  <Reveal delay={delay} className={`group relative overflow-hidden rounded-[1.75rem] border border-white/10 bg-ink-2 p-7 transition-[border-color] duration-500 hover:border-flash/40 sm:p-9 ${className}`}>
    <div data-testid={testid} className="relative flex h-full flex-col">{children}</div>
  </Reveal>
);

export const Bento = () => (
  <section className="relative mx-auto max-w-[1400px] px-5 py-24 sm:px-8 lg:py-32" data-testid="value-bento">
    <div className="grid gap-8 lg:grid-cols-12 lg:items-end">
      <div className="lg:col-span-7">
        <Eyebrow>Como a Eutevila trabalha</Eyebrow>
        <h2 className="mt-5 font-display text-4xl font-bold leading-[0.95] tracking-tight sm:text-6xl">
          <MaskLines animateOnMount={false} lines={["O evento não paga.", <span key="b" className="text-outline-flash">Quem aparece, leva.</span>]} />
        </h2>
      </div>
      <p className="text-base text-haze md:text-lg lg:col-span-5">
        Fotografamos seu evento sem custo para a organização. Cada participante encontra as próprias fotos e paga apenas pelas que quiser, no valor por foto combinado com você.
      </p>
    </div>

    <div className="mt-14 grid gap-4 lg:grid-cols-12 lg:grid-rows-[minmax(260px,auto)_minmax(260px,auto)]">
      <Card className="min-h-[420px] !p-0 lg:col-span-7 lg:row-span-2" testid="bento-free-coverage">
        <img src="/img/lens.jpg" alt="Fotógrafo em evento" className="absolute inset-0 h-full w-full object-cover opacity-70 transition-transform duration-[1.6s] group-hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/60 to-transparent" />
        <div className="relative mt-auto p-7 sm:p-10">
          <span className="inline-flex items-center gap-2 rounded-full bg-flash px-3 py-1 font-mono text-xs font-semibold uppercase text-ink">R$ 0 para o evento</span>
          <h3 className="mt-5 max-w-md font-display text-3xl font-bold leading-tight sm:text-4xl">Cobertura completa, sem custo para quem organiza.</h3>
          <p className="mt-3 max-w-md text-haze">Social, esportivo, empresarial ou particular: levamos fotógrafos associados e cuidamos de tudo.</p>
        </div>
      </Card>
      <Card className="lg:col-span-5" delay={0.08} testid="bento-prepay">
        <QrCode className="h-9 w-9 text-flash" />
        <h3 className="mt-auto pt-10 font-display text-2xl font-bold">Pagamento antecipado</h3>
        <p className="mt-2 text-haze">Pix ou Mercado Pago. Confirmou, liberou — direto no site.</p>
      </Card>
      <div className="grid gap-4 sm:grid-cols-2 lg:col-span-5">
        <Card delay={0.12} testid="bento-download">
          <Download className="h-8 w-8 text-violet-lilac" />
          <h3 className="mt-auto pt-8 font-display text-xl font-bold">Alta resolução, sem marca d'água</h3>
        </Card>
        <Card delay={0.16} className="bg-violet-deep/60" testid="bento-price-per-photo">
          <Handshake className="h-8 w-8 text-flash" />
          <h3 className="mt-auto pt-8 font-display text-xl font-bold">Valor por foto combinado com você</h3>
        </Card>
      </div>
    </div>

    <div className="mt-4 grid gap-4 sm:grid-cols-2">
      <Reveal className="flex items-center gap-4 rounded-[1.75rem] border border-white/10 px-7 py-6" delay={0.05}>
        <Camera className="h-6 w-6 shrink-0 text-flash" />
        <p className="text-foreground/90">Fotógrafos associados criam e publicam as galerias de cada evento.</p>
      </Reveal>
      <Reveal className="flex items-center gap-4 rounded-[1.75rem] border border-white/10 px-7 py-6" delay={0.1}>
        <ShieldCheck className="h-6 w-6 shrink-0 text-flash" />
        <p className="text-foreground/90">Prévias protegidas: o original só é liberado após o pagamento.</p>
      </Reveal>
    </div>
  </section>
);
